import { sql } from "drizzle-orm";

export function workflowV2Jsonb(value: unknown): ReturnType<typeof sql> {
  const json = JSON.stringify(value ?? {}, (_key, current) =>
    typeof current === "string" ? sanitizeWorkflowV2JsonString(current) : current,
  );
  return sql`${json}::text::jsonb`;
}

function sanitizeWorkflowV2JsonString(value: string) {
  return value
    .replace(/\u0000/g, "")
    .replace(/[\uD800-\uDBFF](?![\uDC00-\uDFFF])/g, "")
    .replace(/(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g, "");
}
